import React, { Component } from 'react';
import { useMediaQuery } from 'react-responsive';
import DesktopNavbar from './desktop-nav';
import MobileNavbar from './mobile-nav';
import NotificationSection from './../notification/index';
import TabletNavbar from './tab-nav';

import './_header.scss';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1201 });

  return isDesktop ? children : null;
};

const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1200 });

  return isTablet ? children : null;
};

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return isMobile ? children : null;
};

const Header = () => (
  <React.Fragment>
    <Desktop>
      <NotificationSection />
      <DesktopNavbar />
    </Desktop>

    <Tablet>
      <NotificationSection />
      <TabletNavbar />
    </Tablet>

    <Mobile>
      <MobileNavbar />
      <NotificationSection />
    </Mobile>
  </React.Fragment>
);

export default Header;
